<template>
  <div>
    <a-card title="TrueLife Shop" class="style4 store">
      <a-list :grid="{ gutter: 16, xs: 1, sm: 2, md: 3 }" :data-source="categories">
        <a-list-item slot="renderItem" slot-scope="item" class="mt-4">
          <router-link :to="'/orderProducts/' + item.id">
            <a-card hoverable>
              <img slot="cover" :alt="item.title" :src="item.thumbnail" />
              <!-- <a-card-meta :title="item.title"></a-card-meta> -->
            </a-card>
            <h4>{{ item.name }}</h4>
          </router-link>
        </a-list-item>
      </a-list>
    </a-card>
  </div>
</template>
<script>
import ProductService from '@/services/ProductService';
export default {
  data() {
    return {
      categories: [],
    };
  },
  async mounted() {
    await this.doInitData();
  },
  methods: {
    async doInitData() {
      const store = this.isPastor ? 'invitation' : 'story';
      try {
        this.categories = await ProductService.getCategories({ store });
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
<style lang="scss">
.ant-card-bordered {
  border: none;
  background: transparent;
}
.store {
  & > .ant-card-body {
    background: #e2f5ff !important;
  }

  .ant-list-item {
    text-align: center;
    h4 {
      margin-top: 1rem;
    }
  }
  .ant-card {
    max-width: 240px;
    margin: 0 auto;
  }

  .mt-4 {
    margin-top: 4rem !important;
  }
  .ant-row {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
